xplenty.filter('showNullValues', function () {
  return function (input) {
    if (angular.isUndefined(input) || input === null) {
      return 'null';
    }

    return input;
  };
});
